import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"
import 'tom-select/dist/css/tom-select.css'
import '../stylesheets/tom-select.scss'

export default class extends Controller {
  static targets = ["customerSelect", "contactSelect"]
  static values = { 
    customerSelectUrl: String,
    contactSelectUrl: String
  }

  connect() {
    this.initializeCustomerSelect()
    this.initializeContactSelect()
  }

  testController() {
    // Test Controller Methode
  }

  async loadContactsForCustomer(customerId) {
    if (!customerId) {
      this.clearContactSelect()
      return
    }

    const baseUrl = window.location.origin
    const locale = window.location.pathname.split('/')[1] || 'de'
    
    try {
      const url = `${baseUrl}/${locale}/backend/customers/${customerId}/contacts.json`
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        }
      })
      
      if (response.ok) {
        const contacts = await response.json()
        this.updateContactSelect(contacts)
      } else {
        this.clearContactSelect()
      }
    } catch (error) {
      this.clearContactSelect()
    }
  }

  updateContactSelect(contacts) {
    if (!this.hasContactSelectTarget) {
      return
    }

    // Lösche alle bestehenden Optionen außer der ersten (Placeholder)
    const contactSelect = this.contactSelectTarget
    while (contactSelect.options.length > 1) {
      contactSelect.removeChild(contactSelect.lastChild)
    }

    // Füge neue Optionen hinzu
    if (contacts && contacts.length > 0) {
      contacts.forEach(contact => {
        const option = document.createElement('option')
        option.value = contact.id
        option.textContent = contact.fullname || contact.name || `${(contact.firstname || contact.first_name || '')} ${(contact.lastname || contact.last_name || '')}`.trim()
        contactSelect.appendChild(option)
      })
    } else {
      // Keine Kontakte gefunden
      const option = document.createElement('option')
      option.value = ''
      option.textContent = 'Keine Kontakte gefunden'
      option.disabled = true
      contactSelect.appendChild(option)
    }
  }

  clearContactSelect() {
    if (!this.hasContactSelectTarget) {
      return
    }

    const contactSelect = this.contactSelectTarget
    while (contactSelect.options.length > 1) {
      contactSelect.removeChild(contactSelect.lastChild)
    }

    // Setze auf ersten Wert (Placeholder)
    contactSelect.selectedIndex = 0
  }

  initializeCustomerSelect() {
    if (this.hasCustomerSelectTarget) {
      this.customerTomSelect = new TomSelect(this.customerSelectTarget, {
        valueField: 'id',
        labelField: 'text',
        searchField: ['text'],
        placeholder: "Kunde auswählen...",
        openOnFocus: true,
        preload: 'focus',
        closeAfterSelect: true,
        selectOnTab: true,
        maxOptions: 100,
        create: false,
        load: (query, callback) => {
          if (!query.length) return callback()
          this.loadCustomers(query, callback)
        }
      })

      this.customerTomSelect.on('change', (value) => {
        this.loadContactsForCustomer(value)
      })
    }
  }

  initializeContactSelect() {
    if (this.hasContactSelectTarget) {
      // Einfaches normales Select-Element - kein TomSelect
    }
  }

  async loadCustomers(query, callback) {
    const baseUrl = window.location.origin
    const locale = window.location.pathname.split('/')[1] || 'de'
    
    try {
      const url = `${baseUrl}/${locale}/backend/customers.json?q=${encodeURIComponent(query)}`
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        }
      })
      
      if (response.ok) {
        const customers = await response.json()
        const options = customers.map(customer => ({
          id: customer.id,
          text: customer.name || customer.title || 'Unbekannter Kunde'
        }))
        callback(options)
      } else {
        callback()
      }
    } catch (error) {
      callback()
    }
  }
}
